function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "path24",
  d: "M27.106-34.555l-.066-.063a1.775,1.775,0,0,1-.41-1.245v.129h0V-55.208a1.712,1.712,0,0,1,.475-1.31L38.088-45.536,27.106-34.555M26.63-55.343c0-.049,0-.1,0-.143,0,.046,0,.094,0,.143m0-.145a.006.006,0,0,1,0,0,.006.006,0,0,0,0,0m0-.006h0",
  transform: "translate(-26.63 56.518)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -1.545,
  y1: 1.711,
  x2: -1.537,
  y2: 1.711,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00a0ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.007,
  stopColor: "#00a1ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00beff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512,
  stopColor: "#00d2ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00dfff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00e3ff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "path48",
  d: "M47.525-38.053h0l.083-.047,4.337-2.464a1.9,1.9,0,0,0,.827-.822,1.9,1.9,0,0,1-.827.822L47.608-38.1l-.083.047m0-.13-3.661-3.662,3.661-3.661L51.945-43a1.651,1.651,0,0,1,.929,1.15v0a1.652,1.652,0,0,1-.929,1.149l-4.42,2.511",
  transform: "translate(-43.864 45.506)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: -3.237,
  y1: 4.059,
  x2: -3.227,
  y2: 4.059,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffe000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#ffbd00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff9c00"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "path68",
  d: "M28.1-28.6a1.141,1.141,0,0,1-.783-.288h0a1.142,1.142,0,0,0,.784.288l.081,0-.082,0m0-.13a1.139,1.139,0,0,1-.783-.288h0L38.3-40l3.661,3.662h0l-12.866,7.31a2.042,2.042,0,0,1-.993.3m-.786-.161c-.019-.018-.038-.036-.057-.056l.057.056",
  transform: "translate(-27.256 39.999)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: -1.232,
  y1: 2.333,
  x2: -1.226,
  y2: 2.333,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff3a44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c31162"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-4"
}, /*#__PURE__*/React.createElement("path", {
  id: "path84",
  d: "M38.327-45.746h0L27.345-56.729a1.141,1.141,0,0,1,.783-.288,2.045,2.045,0,0,1,.995.3l12.866,7.31-3.661,3.661m3.744-3.744L29.122-56.848a2.044,2.044,0,0,0-.995-.3h0a2.04,2.04,0,0,1,.993.3L42.071-49.49m-13.95-7.655h0",
  transform: "translate(-27.345 57.146)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: -1.234,
  y1: 3.333,
  x2: -1.228,
  y2: 3.333,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#32a071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.068,
  stopColor: "#2da771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.476,
  stopColor: "#15cf74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.801,
  stopColor: "#06e775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00f076"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5"
}, /*#__PURE__*/React.createElement("path", {
  id: "path108",
  d: "M49.37-34.319h0l.083-.047-.083.047",
  transform: "translate(-49.37 34.367)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: -393.081,
  y1: 481.772,
  x2: -392.02,
  y2: 481.772,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ccb300"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#cc9700"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "#cc8400"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cc7d00"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-6"
}, /*#__PURE__*/React.createElement("path", {
  id: "path128",
  d: "M28.1-26.753a1.142,1.142,0,0,1-.784-.288h0l0,0-.057-.056-.006-.006.066-.066a1.139,1.139,0,0,0,.783.288,2.042,2.042,0,0,0,.993-.3l12.866-7.31.082.082-.083.047-12.865,7.31a2.119,2.119,0,0,1-.912.3l-.081,0",
  transform: "translate(-27.247 34.491)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: -1.225,
  y1: 2.963,
  x2: -1.219,
  y2: 2.963,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cc2e36"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9c0e4e"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-7"
}, /*#__PURE__*/React.createElement("path", {
  id: "path146",
  d: "M27.04-24.074h0a1.774,1.774,0,0,1-.41-1.245v-.129a1.775,1.775,0,0,0,.41,1.245l.066.063-.066.066",
  transform: "translate(-26.63 25.449)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: -37.186,
  y1: 12.308,
  x2: -37,
  y2: 12.308,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#008de0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.007,
  stopColor: "#008de0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00a7e0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512,
  stopColor: "#00b8e0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00c4e0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00c7e0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-8"
}, /*#__PURE__*/React.createElement("path", {
  id: "path170",
  d: "M27.247-23.414h0l.066-.066h0l-.066.066",
  transform: "translate(-27.247 23.481)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: -275.042,
  y1: 236.065,
  x2: -273.696,
  y2: 236.065,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e0333c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ab0f56"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-9"
}, /*#__PURE__*/React.createElement("path", {
  id: "path188",
  d: "M49.454-36.254h0l-.082-.082,4.42-2.511A1.652,1.652,0,0,0,54.72-40a1.1,1.1,0,0,1-.1.457,1.9,1.9,0,0,1-.827.822l-4.337,2.464",
  transform: "translate(-49.372 39.997)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: -6.137,
  y1: 7.104,
  x2: -6.12,
  y2: 7.104,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e0c500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#e0a600"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "#e09100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e08900"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-10"
}, /*#__PURE__*/React.createElement("path", {
  id: "path210",
  d: "M54.72-41.887a1.651,1.651,0,0,0-.929-1.15l-4.42-2.511.082-.082h0l4.337,2.464a1.556,1.556,0,0,1,.929,1.279",
  transform: "translate(-49.371 45.63)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: -6.136,
  y1: 8.104,
  x2: -6.12,
  y2: 8.104,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffe840"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#ffce40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "#ffbc40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffb540"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-11"
}, /*#__PURE__*/React.createElement("path", {
  id: "path232",
  d: "M26.63-55.273v-.134h0c0-.049,0-.1,0-.143v0a.006.006,0,0,1,0,0v0h0a1.689,1.689,0,0,1,.406-1.088h0l.065.065a1.712,1.712,0,0,0-.475,1.31M27.1-56.71l0,0,0,0",
  transform: "translate(-26.63 56.713)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: -37.214,
  y1: 26.187,
  x2: -37.027,
  y2: 26.187,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#40b8ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.007,
  stopColor: "#40b9ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#40ceff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512,
  stopColor: "#40ddff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#40e7ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#40eaff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-12"
}, /*#__PURE__*/React.createElement("path", {
  id: "path258",
  d: "M41.955-49.408l-12.866-7.31a2.045,2.045,0,0,0-.995-.3,1.141,1.141,0,0,0-.783.288l-.065-.065h0c.02-.021.041-.042.063-.062l0,0a1.14,1.14,0,0,1,.775-.288h.007a2.044,2.044,0,0,1,.995.3L42.038-49.49h0l-.082.082",
  transform: "translate(-27.247 57.146)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: -1.225,
  y1: 4.91,
  x2: -1.219,
  y2: 4.91,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#65b895"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.068,
  stopColor: "#62bd95"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.476,
  stopColor: "#50db97"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.801,
  stopColor: "#44ed98"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#40f498"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "g8",
  transform: "translate(-13.333 66.667)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g10",
  transform: "translate(13.333 -66.667)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path14",
  d: "M128.565-26.666H17.765a4.756,4.756,0,0,1-4.432-5v-30a4.756,4.756,0,0,1,4.432-5h110.8a4.756,4.756,0,0,1,4.432,5v30a4.756,4.756,0,0,1-4.432,5",
  transform: "translate(-13.333 66.667)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path16",
  d: "M128.565-66.667H17.765a4.756,4.756,0,0,0-4.432,5v30a4.756,4.756,0,0,0,4.432,5h110.8a4.756,4.756,0,0,0,4.432-5v-30a4.756,4.756,0,0,0-4.432-5m0,.8a3.988,3.988,0,0,1,3.723,4.2v30a3.988,3.988,0,0,1-3.723,4.2H17.765a3.988,3.988,0,0,1-3.723-4.2v-30a3.988,3.988,0,0,1,3.723-4.2h110.8",
  transform: "translate(-13.333 66.667)",
  fill: "#a6a6a6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path18",
  d: "M126.464-32.456h1.654V-43.537h-1.654Zm14.9-7.089-1.9,4.8h-.057l-1.968-4.8H135.66l2.951,6.715L136.928-29.1h1.726l4.547-10.45Zm-9.38,5.831c-.542,0-1.3-.271-1.3-.941,0-.855.941-1.183,1.753-1.183a2.944,2.944,0,0,1,1.511.371A2.005,2.005,0,0,1,131.982-33.714Zm.2-6.073a3.105,3.105,0,0,0-2.951,1.7l1.468.613a1.568,1.568,0,0,1,1.511-.813,1.593,1.593,0,0,1,1.739,1.426v.114a3.658,3.658,0,0,0-1.725-.428c-1.582,0-3.194.869-3.194,2.495a2.56,2.56,0,0,0,2.751,2.438,2.335,2.335,0,0,0,2.111-1.083h.057v.855h1.6v-4.249c0-1.967-1.468-3.065-3.364-3.065ZM121.96-38.2h-2.353v-3.8h2.353a1.92,1.92,0,0,1,1.939,1.9A1.93,1.93,0,0,1,121.96-38.2Zm-.043-5.341h-3.963v11.081h1.653v-4.2h2.31a3.511,3.511,0,0,0,3.635-3.441A3.511,3.511,0,0,0,121.917-43.537Zm-21.611,9.825a2.163,2.163,0,0,1-2.1-2.271,2.181,2.181,0,0,1,2.1-2.3,2.125,2.125,0,0,1,2.013,2.3A2.107,2.107,0,0,1,100.306-33.712Zm1.9-5.212h-.057a2.613,2.613,0,0,0-1.985-.842,3.749,3.749,0,0,0-3.613,3.784,3.733,3.733,0,0,0,3.613,3.756,2.571,2.571,0,0,0,1.985-.857h.057v.543c0,1.443-.771,2.214-2.013,2.214a2.087,2.087,0,0,1-1.9-1.342l-1.442.6a3.593,3.593,0,0,0,3.342,2.228c1.942,0,3.584-1.143,3.584-3.927v-6.769H102.2Zm2.713,6.469h1.656V-43.537h-1.656Zm4.1-3.656a2.068,2.068,0,0,1,1.971-2.2,1.458,1.458,0,0,1,1.4.8Zm5.141-1.257a3.5,3.5,0,0,0-3.227-2.4A3.583,3.583,0,0,0,107.374-36a3.689,3.689,0,0,0,3.741,3.77,3.75,3.75,0,0,0,3.142-1.671l-1.285-.857a2.153,2.153,0,0,1-1.857,1.043,1.918,1.918,0,0,1-1.828-1.142l5.041-2.085ZM74-38.61v1.6h3.827A3.338,3.338,0,0,1,76.952-35,3.917,3.917,0,0,1,74-33.826a4.2,4.2,0,0,1-4.2-4.255A4.2,4.2,0,0,1,74-42.337a4.079,4.079,0,0,1,2.885,1.143l1.128-1.128A5.578,5.578,0,0,0,74-43.937a5.937,5.937,0,0,0-5.941,5.855A5.937,5.937,0,0,0,74-32.227a5.351,5.351,0,0,0,4.084-1.642,5.285,5.285,0,0,0,1.385-3.741,5.19,5.19,0,0,0-.086-1Zm9.82,4.9A2.181,2.181,0,0,1,81.688-36a2.172,2.172,0,0,1,2.128-2.285A2.172,2.172,0,0,1,85.944-36,2.181,2.181,0,0,1,83.817-33.712Zm0-6.055A3.716,3.716,0,0,0,80.032-36a3.725,3.725,0,0,0,3.785,3.77A3.725,3.725,0,0,0,87.6-36,3.716,3.716,0,0,0,83.817-39.767Zm8.255,6.055A2.181,2.181,0,0,1,89.944-36a2.172,2.172,0,0,1,2.128-2.285A2.172,2.172,0,0,1,94.2-36,2.181,2.181,0,0,1,92.072-33.712Zm0-6.055A3.716,3.716,0,0,0,88.288-36a3.725,3.725,0,0,0,3.784,3.77A3.725,3.725,0,0,0,95.856-36a3.716,3.716,0,0,0-3.784-3.77",
  transform: "translate(-31.676 63.592)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "g20",
  transform: "translate(8.84 9.019)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g22",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path42",
  d: "M27.106-34.555l-.066-.063a1.775,1.775,0,0,1-.41-1.245v.129h0V-55.208a1.712,1.712,0,0,1,.475-1.31L38.088-45.536,27.106-34.555M26.63-55.343c0-.049,0-.1,0-.143,0,.046,0,.094,0,.143m0-.145a.006.006,0,0,1,0,0,.006.006,0,0,0,0,0m0-.006h0",
  transform: "translate(-26.63 56.518)",
  fill: "url(#linear-gradient)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "g44",
  transform: "translate(20.297 16.35)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g46",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path62",
  d: "M47.525-38.053h0l.083-.047,4.337-2.464a1.9,1.9,0,0,0,.827-.822,1.9,1.9,0,0,1-.827.822L47.608-38.1l-.083.047m0-.13-3.661-3.662,3.661-3.661L51.945-43a1.651,1.651,0,0,1,.929,1.15v0a1.652,1.652,0,0,1-.929,1.149l-4.42,2.511",
  transform: "translate(-43.864 45.506)",
  fill: "url(#linear-gradient-2)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "g64",
  transform: "translate(9.256 21.078)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g66",
  clipPath: "url(#clip-path-3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path78",
  d: "M28.1-28.6a1.141,1.141,0,0,1-.783-.288h0a1.142,1.142,0,0,0,.784.288l.081,0-.082,0m0-.13a1.139,1.139,0,0,1-.783-.288h0L38.3-40l3.661,3.662h0l-12.866,7.31a2.042,2.042,0,0,1-.993.3m-.786-.161c-.019-.018-.038-.036-.057-.056l.057.056",
  transform: "translate(-27.256 39.999)",
  fill: "url(#linear-gradient-3)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "g80",
  transform: "translate(9.315 7.525)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g82",
  clipPath: "url(#clip-path-4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path100",
  d: "M38.327-45.746h0L27.345-56.729a1.141,1.141,0,0,1,.783-.288,2.045,2.045,0,0,1,.995.3l12.866,7.31-3.661,3.661m3.744-3.744L29.122-56.848a2.044,2.044,0,0,0-.995-.3h0a2.04,2.04,0,0,1,.993.3L42.071-49.49m-13.95-7.655h0",
  transform: "translate(-27.345 57.146)",
  fill: "url(#linear-gradient-4)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "path102",
  d: "M28.178-26.689a2.119,2.119,0,0,0,.912-.3L41.955-34.3h0l-12.865,7.31a2.113,2.113,0,0,1-.912.3m-.865-.286,0,0,0,0h0m-.06-.058-.006-.005h0l.006.006",
  transform: "translate(-17.997 59.327)"
}), /*#__PURE__*/React.createElement("g", {
  id: "g104",
  transform: "translate(23.957 24.229)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g106",
  clipPath: "url(#clip-path-5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path122",
  d: "M49.37-34.319h0l.083-.047-.083.047",
  transform: "translate(-49.37 34.367)",
  fill: "url(#linear-gradient-5)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "g124",
  transform: "translate(9.25 24.897)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g126",
  clipPath: "url(#clip-path-6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path138",
  d: "M28.1-26.753a1.142,1.142,0,0,1-.784-.288h0l0,0-.057-.056-.006-.006.066-.066a1.139,1.139,0,0,0,.783.288,2.042,2.042,0,0,0,.993-.3l12.866-7.31.082.082-.083.047-12.865,7.31a2.119,2.119,0,0,1-.912.3l-.081,0",
  transform: "translate(-27.247 34.491)",
  fill: "url(#linear-gradient-6)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "path140",
  d: "M27.04-24.009a1.775,1.775,0,0,1-.41-1.245h0a1.774,1.774,0,0,0,.41,1.245h0",
  transform: "translate(-17.79 56.442)"
}), /*#__PURE__*/React.createElement("g", {
  id: "g142",
  transform: "translate(8.84 31.055)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g144",
  transform: "translate(0 0)",
  clipPath: "url(#clip-path-7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path164",
  d: "M27.04-24.074h0a1.774,1.774,0,0,1-.41-1.245v-.129a1.775,1.775,0,0,0,.41,1.245l.066.063-.066.066",
  transform: "translate(-26.63 25.449)",
  fill: "url(#linear-gradient-7)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "g166",
  transform: "translate(9.25 33.254)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g168",
  clipPath: "url(#clip-path-8)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path180",
  d: "M27.247-23.414h0l.066-.066h0l-.066.066",
  transform: "translate(-27.247 23.481)",
  fill: "url(#linear-gradient-8)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "path182",
  d: "M57.263-39.54a1.1,1.1,0,0,0,.1-.457h0a1.1,1.1,0,0,1-.1.458",
  transform: "translate(-28.058 60.029)"
}), /*#__PURE__*/React.createElement("g", {
  id: "g184",
  transform: "translate(23.958 20.271)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g186",
  clipPath: "url(#clip-path-9)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path202",
  d: "M49.454-36.254h0l-.082-.082,4.42-2.511A1.652,1.652,0,0,0,54.72-40a1.1,1.1,0,0,1-.1.457,1.9,1.9,0,0,1-.827.822l-4.337,2.464",
  transform: "translate(-49.372 39.997)",
  fill: "url(#linear-gradient-9)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "path204",
  d: "M54.762-41.887h0a1.556,1.556,0,0,0-.929-1.279L49.5-45.63h0l4.337,2.464a1.554,1.554,0,0,1,.929,1.28",
  transform: "translate(-25.455 61.619)",
  fill: "#404040"
}), /*#__PURE__*/React.createElement("g", {
  id: "g206",
  transform: "translate(23.958 15.989)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g208",
  clipPath: "url(#clip-path-10)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path224",
  d: "M54.72-41.887a1.651,1.651,0,0,0-.929-1.15l-4.42-2.511.082-.082h0l4.337,2.464a1.556,1.556,0,0,1,.929,1.279",
  transform: "translate(-49.371 45.63)",
  fill: "url(#linear-gradient-10)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "path226",
  d: "M26.63-55.553h0m0-.144v0m0,0v0m0-.005c.051-.911.546-1.437,1.247-1.44a1.14,1.14,0,0,0-.775.288h0l0,0c-.022.02-.043.041-.063.062h0a1.689,1.689,0,0,0-.406,1.088",
  transform: "translate(-17.79 64.325)",
  fill: "#404040"
}), /*#__PURE__*/React.createElement("g", {
  id: "g228",
  transform: "translate(8.84 7.501)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g230",
  clipPath: "url(#clip-path-11)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path250",
  d: "M26.63-55.273v-.134h0c0-.049,0-.1,0-.143v0a.006.006,0,0,1,0,0v0h0a1.689,1.689,0,0,1,.406-1.088h0l.065.065a1.712,1.712,0,0,0-.475,1.31M27.1-56.71l0,0,0,0",
  transform: "translate(-26.63 56.713)",
  fill: "url(#linear-gradient-11)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "path252",
  d: "M28.512-57.146h0",
  transform: "translate(-18.421 63.475)",
  fill: "#404040"
}), /*#__PURE__*/React.createElement("g", {
  id: "g254",
  transform: "translate(9.25 7.367)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g256",
  clipPath: "url(#clip-path-12)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path274",
  d: "M41.955-49.408l-12.866-7.31a2.045,2.045,0,0,0-.995-.3,1.141,1.141,0,0,0-.783.288l-.065-.065h0c.02-.021.041-.042.063-.062l0,0a1.14,1.14,0,0,1,.775-.288h.007a2.044,2.044,0,0,1,.995.3L42.038-49.49h0l-.082.082",
  transform: "translate(-27.247 57.146)",
  fill: "url(#linear-gradient-12)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "path276",
  d: "M69.057-52.668H70A2,2,0,0,0,71.46-53.2,1.973,1.973,0,0,0,72-54.674a1.977,1.977,0,0,0-.538-1.475A1.991,1.991,0,0,0,70-56.68h-.943Zm-.683.653v-5.318H70a2.644,2.644,0,0,1,1.962.739,2.6,2.6,0,0,1,.735,1.92,2.6,2.6,0,0,1-.735,1.92A2.644,2.644,0,0,1,70-52.015H68.374",
  transform: "translate(-31.783 64.474)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path278",
  d: "M69.012-52.713v.089h.943a2.084,2.084,0,0,0,1.521-.553,2.062,2.062,0,0,0,.565-1.542,2.066,2.066,0,0,0-.565-1.538h0a2.079,2.079,0,0,0-1.522-.557H68.923v4.189h.089v-.089H69.1v-3.923h.855a1.9,1.9,0,0,1,1.4.506h0a1.889,1.889,0,0,1,.512,1.412,1.885,1.885,0,0,1-.512,1.415,1.909,1.909,0,0,1-1.4.5h-.943v.089h0Zm-.683.653h.089v-5.23h1.538a2.555,2.555,0,0,1,1.9.713,2.514,2.514,0,0,1,.709,1.857,2.513,2.513,0,0,1-.709,1.857,2.553,2.553,0,0,1-1.9.713H68.329v.089h0v.089h1.626a2.732,2.732,0,0,0,2.024-.765,2.694,2.694,0,0,0,.761-1.983A2.692,2.692,0,0,0,71.98-56.7a2.731,2.731,0,0,0-2.024-.766H68.241v5.5h.089v-.089",
  transform: "translate(-31.738 64.51)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path280",
  d: "M76.319-52.015v-5.318H77v5.318h-.683",
  transform: "translate(-34.446 64.474)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path282",
  d: "M76.274-52.059h.089v-5.23h.506v5.141h-.594v.089h0v.089h.771v-5.5h-.86v5.5h.089v-.089",
  transform: "translate(-34.401 64.51)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path284",
  d: "M80.5-51.956a1.983,1.983,0,0,1-1.132-.378,1.751,1.751,0,0,1-.725-1.063l.624-.252a1.421,1.421,0,0,0,.456.739,1.153,1.153,0,0,0,.776.3,1.246,1.246,0,0,0,.762-.234.748.748,0,0,0,.315-.635.814.814,0,0,0-.315-.687,3.267,3.267,0,0,0-1-.449,2.667,2.667,0,0,1-1.07-.576,1.2,1.2,0,0,1-.365-.9,1.32,1.32,0,0,1,.454-1,1.662,1.662,0,0,1,1.181-.424,1.708,1.708,0,0,1,1.1.338,1.562,1.562,0,0,1,.55.739l-.623.259a.925.925,0,0,0-.331-.468,1.044,1.044,0,0,0-.68-.215,1.05,1.05,0,0,0-.672.219.667.667,0,0,0-.279.546.621.621,0,0,0,.256.5,2.457,2.457,0,0,0,.754.368,6.568,6.568,0,0,1,.658.245,3.005,3.005,0,0,1,.534.316,1.253,1.253,0,0,1,.409.49,1.584,1.584,0,0,1,.138.679,1.462,1.462,0,0,1-.16.691,1.294,1.294,0,0,1-.424.483,2.1,2.1,0,0,1-.568.271,2.131,2.131,0,0,1-.624.093",
  transform: "translate(-35.225 64.523)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path286",
  d: "M80.446-52v-.089a1.9,1.9,0,0,1-1.082-.363,1.661,1.661,0,0,1-.689-1.011l-.086.021.033.082.624-.252-.033-.082-.086.022a1.512,1.512,0,0,0,.484.784h0a1.243,1.243,0,0,0,.834.322,1.335,1.335,0,0,0,.814-.251.839.839,0,0,0,.351-.707.9.9,0,0,0-.35-.757,3.351,3.351,0,0,0-1.027-.464h0A2.574,2.574,0,0,1,79.2-55.3a1.115,1.115,0,0,1-.338-.839,1.232,1.232,0,0,1,.426-.93,1.573,1.573,0,0,1,1.12-.4,1.621,1.621,0,0,1,1.044.319,1.477,1.477,0,0,1,.52.7l.084-.026-.034-.082-.624.26.034.082.086-.023a1.011,1.011,0,0,0-.36-.513h0a1.132,1.132,0,0,0-.736-.235,1.14,1.14,0,0,0-.727.238h0a.759.759,0,0,0-.313.616.711.711,0,0,0,.29.571h0a2.539,2.539,0,0,0,.781.382h0a6.275,6.275,0,0,1,.648.242h0a2.915,2.915,0,0,1,.518.306h0a1.167,1.167,0,0,1,.38.456,1.49,1.49,0,0,1,.13.642,1.38,1.38,0,0,1-.149.65,1.212,1.212,0,0,1-.4.45h0a2.007,2.007,0,0,1-.544.26,2.036,2.036,0,0,1-.6.089v.177a2.219,2.219,0,0,0,.65-.1,2.2,2.2,0,0,0,.592-.282h0a1.385,1.385,0,0,0,.453-.515,1.553,1.553,0,0,0,.17-.732,1.677,1.677,0,0,0-.146-.717,1.349,1.349,0,0,0-.437-.525h0a3.072,3.072,0,0,0-.55-.325h0a6.476,6.476,0,0,0-.667-.249h0a2.375,2.375,0,0,1-.726-.353h0a.531.531,0,0,1-.223-.432.578.578,0,0,1,.245-.476h0a.961.961,0,0,1,.617-.2.952.952,0,0,1,.624.2h0a.839.839,0,0,1,.3.422l.026.1.717-.3.075-.031-.024-.077a1.652,1.652,0,0,0-.579-.782,1.8,1.8,0,0,0-1.154-.357,1.75,1.75,0,0,0-1.241.448,1.411,1.411,0,0,0-.482,1.06,1.294,1.294,0,0,0,.392.966,2.756,2.756,0,0,0,1.1.6h0a3.206,3.206,0,0,1,.971.435.725.725,0,0,1,.28.617.658.658,0,0,1-.279.564,1.155,1.155,0,0,1-.709.216,1.065,1.065,0,0,1-.719-.279h0a1.334,1.334,0,0,1-.428-.694l-.025-.1-.718.29-.072.029.019.075a1.84,1.84,0,0,0,.761,1.114,2.072,2.072,0,0,0,1.182.394V-52",
  transform: "translate(-35.172 64.56)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path288",
  d: "M86.264-54.823h1.144a.883.883,0,0,0,.691-.289.936.936,0,0,0,.259-.639.935.935,0,0,0-.259-.639.881.881,0,0,0-.691-.29H86.264Zm0,2.808H85.58v-5.318h1.813a1.679,1.679,0,0,1,1.169.449,1.465,1.465,0,0,1,.494,1.133,1.463,1.463,0,0,1-.494,1.132,1.678,1.678,0,0,1-1.169.45H86.264v2.154",
  transform: "translate(-37.55 64.474)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path290",
  d: "M86.219-54.868v.089h1.144a.973.973,0,0,0,.757-.318h0a1.026,1.026,0,0,0,.282-.7,1.025,1.025,0,0,0-.282-.7h0a.97.97,0,0,0-.757-.32H86.13v2.034h.089v-.089h.089v-1.768h1.056a.793.793,0,0,1,.625.261h0a.845.845,0,0,1,.237.58.846.846,0,0,1-.237.58h0a.792.792,0,0,1-.625.26H86.219v.089h0Zm0,2.808v-.089h-.595v-5.141h1.724a1.591,1.591,0,0,1,1.11.426h0a1.374,1.374,0,0,1,.465,1.067,1.374,1.374,0,0,1-.465,1.067h0a1.59,1.59,0,0,1-1.11.427H86.13v2.243h.089v0h.089v-2.065h1.041a1.769,1.769,0,0,0,1.229-.473h0a1.553,1.553,0,0,0,.523-1.2,1.555,1.555,0,0,0-.523-1.2h0a1.769,1.769,0,0,0-1.229-.472h-1.9v5.5h.861v-.089h-.089",
  transform: "translate(-37.506 64.51)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path292",
  d: "M92.891-53.207a1.952,1.952,0,0,0,1.445.6,1.95,1.95,0,0,0,1.444-.6,2.081,2.081,0,0,0,.591-1.527,2.081,2.081,0,0,0-.591-1.527,1.95,1.95,0,0,0-1.444-.6,1.952,1.952,0,0,0-1.445.6,2.083,2.083,0,0,0-.59,1.527A2.083,2.083,0,0,0,92.891-53.207Zm3.395.445a2.61,2.61,0,0,1-1.95.806,2.606,2.606,0,0,1-1.949-.806,2.719,2.719,0,0,1-.783-1.972,2.719,2.719,0,0,1,.783-1.972,2.606,2.606,0,0,1,1.949-.806,2.608,2.608,0,0,1,1.947.81,2.72,2.72,0,0,1,.787,1.968,2.723,2.723,0,0,1-.783,1.972",
  transform: "translate(-39.569 64.523)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path294",
  d: "M92.846-53.252l-.063.062a2.042,2.042,0,0,0,1.508.624A2.041,2.041,0,0,0,95.8-53.19a2.173,2.173,0,0,0,.617-1.589,2.173,2.173,0,0,0-.617-1.589h0a2.041,2.041,0,0,0-1.508-.624,2.042,2.042,0,0,0-1.508.624l0,0,0,0a2.173,2.173,0,0,0-.616,1.589,2.173,2.173,0,0,0,.616,1.589l.063-.062.063-.062a1.994,1.994,0,0,1-.565-1.464,1.994,1.994,0,0,1,.565-1.464h0a1.863,1.863,0,0,1,1.382-.571,1.862,1.862,0,0,1,1.382.571h0a1.991,1.991,0,0,1,.566,1.464,1.991,1.991,0,0,1-.566,1.464,1.862,1.862,0,0,1-1.382.571,1.863,1.863,0,0,1-1.382-.571Zm3.395.445-.064-.062a2.522,2.522,0,0,1-1.887.779,2.518,2.518,0,0,1-1.886-.779h0a2.632,2.632,0,0,1-.758-1.91,2.632,2.632,0,0,1,.758-1.91h0a2.518,2.518,0,0,1,1.886-.779,2.519,2.519,0,0,1,1.883.783,2.629,2.629,0,0,1,.762,1.906,2.633,2.633,0,0,1-.758,1.91l.064.062.063.062a2.812,2.812,0,0,0,.808-2.033,2.808,2.808,0,0,0-.812-2.03,2.7,2.7,0,0,0-2.01-.837,2.7,2.7,0,0,0-2.013.833h0a2.809,2.809,0,0,0-.809,2.034,2.809,2.809,0,0,0,.809,2.034l0,0,0,0a2.7,2.7,0,0,0,2.013.833,2.7,2.7,0,0,0,2.014-.833l-.063-.062",
  transform: "translate(-39.524 64.56)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path296",
  d: "M101.268-52.015v-5.318h.832l2.585,4.137h.029l-.029-1.025v-3.112h.684v5.318h-.713l-2.7-4.338h-.029l.029,1.025v3.313h-.683",
  transform: "translate(-42.809 64.474)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path298",
  d: "M101.223-52.059h.089v-5.23h.694l2.585,4.137h.17l-.032-1.115v-3.022h.506v5.141h-.576l-2.7-4.338h-.17l.032,1.115v3.223h-.595v.089h0v.089H102v-3.4l-.03-1.026-.088,0v.089h.029V-56.4l-.076.047,2.731,4.379h.851v-5.5h-.861v3.2l.029,1.026.089,0v-.089h-.029v.089l.075-.047L102.1-57.467h-.969v5.5h.089v-.089",
  transform: "translate(-42.764 64.51)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path300",
  d: "M109.268-52.015v-5.318h.683v5.318h-.683",
  transform: "translate(-45.49 64.474)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path302",
  d: "M109.223-52.059h.089v-5.23h.506v5.141h-.595v.089h0v.089H110v-5.5h-.86v5.5h.089v-.089",
  transform: "translate(-45.446 64.51)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path304",
  d: "M112.81-52.668h1.375a.815.815,0,0,0,.639-.276.883.883,0,0,0,.245-.6.858.858,0,0,0-.253-.6.861.861,0,0,0-.661-.271H112.81Zm0-2.385h1.241a.8.8,0,0,0,.62-.256.814.814,0,0,0,.234-.561.812.812,0,0,0-.227-.557.761.761,0,0,0-.6-.253H112.81Zm-.683,3.038v-5.318h1.923a1.563,1.563,0,0,1,1.081.412,1.337,1.337,0,0,1,.457,1.036,1.157,1.157,0,0,1-.2.669,1.234,1.234,0,0,1-.524.438v.029a1.35,1.35,0,0,1,.647.46,1.211,1.211,0,0,1,.252.758,1.4,1.4,0,0,1-.48,1.084,1.637,1.637,0,0,1-1.133.431h-2.027",
  transform: "translate(-46.449 64.474)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path306",
  d: "M112.765-52.713v.089h1.375a.906.906,0,0,0,.7-.305h0a.972.972,0,0,0,.268-.661.947.947,0,0,0-.277-.658h0a.951.951,0,0,0-.726-.3h-1.433v1.923h.089v-.089h.089V-54.37h1.256a.773.773,0,0,1,.6.243h0a.769.769,0,0,1,.229.537.794.794,0,0,1-.222.543h0a.726.726,0,0,1-.572.246h-1.375v.089h0Zm0-2.385v.089h1.241a.888.888,0,0,0,.686-.285h0a.906.906,0,0,0,.257-.62.9.9,0,0,0-.25-.616h0a.852.852,0,0,0-.663-.283h-1.359v1.8h.089V-55.1h.089v-1.538h1.182a.675.675,0,0,1,.531.223h0a.725.725,0,0,1,.2.5.726.726,0,0,1-.211.5h0a.708.708,0,0,1-.555.227h-1.241v.089h0Zm-.683,3.038h.089v-5.23h1.835a1.473,1.473,0,0,1,1.022.389h0a1.249,1.249,0,0,1,.428.971,1.071,1.071,0,0,1-.182.619h0a1.144,1.144,0,0,1-.487.408l-.052.024v.15l.06.02a1.264,1.264,0,0,1,.6.431h0a1.119,1.119,0,0,1,.234.7,1.3,1.3,0,0,1-.45,1.018,1.548,1.548,0,0,1-1.074.408h-2.027v.089h0v.089h2.027a1.727,1.727,0,0,0,1.192-.454,1.485,1.485,0,0,0,.509-1.15,1.3,1.3,0,0,0-.271-.812h0a1.441,1.441,0,0,0-.688-.49l-.028.084h.089v-.029h-.089l.037.081a1.322,1.322,0,0,0,.561-.47h0a1.251,1.251,0,0,0,.213-.718,1.429,1.429,0,0,0-.487-1.1l0,0,0,0a1.651,1.651,0,0,0-1.141-.435h-2.012v5.5h.089v-.089",
  transform: "translate(-46.404 64.51)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path308",
  d: "M118.988-52.015v-5.318h.683v4.665h2.3v.653h-2.986",
  transform: "translate(-48.748 64.474)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path310",
  d: "M118.943-52.059h.089v-5.23h.506v4.665h2.3v.476h-2.9v.089h0v.089h3.074V-52.8h-2.3v-4.665h-.86v5.5h.089v-.089",
  transform: "translate(-48.704 64.51)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path312",
  d: "M127.881-56.68h-2.422v1.686h2.184v.639h-2.184v1.686h2.422v.653h-3.105v-5.318h3.105v.653",
  transform: "translate(-50.689 64.474)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path314",
  d: "M127.836-56.725v-.089h-2.511v1.864h2.184v.462h-2.184v1.864h2.422v.476H124.82v-5.141h2.928v.565h.089v0h.089v-.742h-3.283v5.5h3.283V-52.8H125.5v-1.509h2.184v-.816H125.5v-1.509h2.422v-.089h-.089",
  transform: "translate(-50.644 64.51)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path316",
  d: "M136.842-56.68H134.42v1.686H136.6v.639H134.42v1.686h2.423v.653h-3.105v-5.318h3.105v.653",
  transform: "translate(-53.692 64.474)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path318",
  d: "M136.8-56.725v-.089h-2.511v1.864h2.184v.462h-2.184v1.864h2.423v.476h-2.928v-5.141h2.928v.565h.089v0h.089v-.742H133.6v5.5h3.282V-52.8h-2.423v-1.509h2.184v-.816h-2.184v-1.509h2.423v-.089H136.8",
  transform: "translate(-53.648 64.51)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path320",
  d: "M140.016-52.015v-5.318h.831l2.585,4.137h.029l-.029-1.025v-3.112h.684v5.318H143.4l-2.7-4.338h-.029l.029,1.025v3.313h-.683",
  transform: "translate(-55.797 64.474)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "path322",
  d: "M139.971-52.059h.089v-5.23h.694l2.585,4.137h.169l-.032-1.115v-3.022h.507v5.141h-.576l-2.7-4.338h-.17l.032,1.115v3.223h-.594v.089h0v.089h.771v-3.4l-.029-1.026-.089,0v.089h.029V-56.4l-.075.047,2.731,4.379h.851v-5.5H143.3v3.2l.029,1.026.089,0v-.089h-.029v.089l.075-.047-2.61-4.179h-.97v5.5h.089v-.089",
  transform: "translate(-55.752 64.51)",
  fill: "#fff"
})));

var SvgDownloadButtonAndroidIcon = function SvgDownloadButtonAndroidIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119.664,
    height: 40,
    viewBox: "0 0 119.664 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadButtonAndroidIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download-button-android-icon.40824df6.svg";
export { ForwardRef as ReactComponent };